import React, { useEffect } from 'react';

const TesteCookie = () => {
  useEffect(() => {
    if (document.cookie.indexOf('JWT_TOKEN') < 0) {
      alert('Ocorreu algum erro ao gravar o cookie');
    } else {
      alert('Cookie salvo com sucesso');
    }
  }, []);

  return null;
};

export default TesteCookie;
